// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.documentsTable {
    width: 100%;
    margin: 0;
}

.documentsTable form {
    border: 2px solid #f09502;
    padding: 45px;
    color: white;
    background-color: #0e0f15;
}

.documentsTable form button {
    display: block;
    max-width: 60%;
    margin: 0 auto;
}

.documentsTable table tr th {
    border: 2px solid #f09502;
}

.documentsTable table tr th {
    color: white;
    padding: 8px 12px;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #0e0f15;
}

.documentsTable table tr th div {
    max-width: 90%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.documentsTable table tr th div i {
    display: block;
    margin-right: 5px;
}

.documentsTable table tr th div a {
    text-decoration: none;
}

.documentsTable table tr th span {
    max-width: 10%;
    display: block;
    margin-right: 15px;
    color: brown;
}

@media (max-width: 500px) {
    .documentsTable form {
        padding: 10px;
    }

    .documentsTable form button {
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/documentation-general/documentation-general.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.documentsTable {\n    width: 100%;\n    margin: 0;\n}\n\n.documentsTable form {\n    border: 2px solid #f09502;\n    padding: 45px;\n    color: white;\n    background-color: #0e0f15;\n}\n\n.documentsTable form button {\n    display: block;\n    max-width: 60%;\n    margin: 0 auto;\n}\n\n.documentsTable table tr th {\n    border: 2px solid #f09502;\n}\n\n.documentsTable table tr th {\n    color: white;\n    padding: 8px 12px;\n    margin-bottom: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #0e0f15;\n}\n\n.documentsTable table tr th div {\n    max-width: 90%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.documentsTable table tr th div i {\n    display: block;\n    margin-right: 5px;\n}\n\n.documentsTable table tr th div a {\n    text-decoration: none;\n}\n\n.documentsTable table tr th span {\n    max-width: 10%;\n    display: block;\n    margin-right: 15px;\n    color: brown;\n}\n\n@media (max-width: 500px) {\n    .documentsTable form {\n        padding: 10px;\n    }\n\n    .documentsTable form button {\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
